import React from "react";
import Hero from "./Hero";
import { Intro, WhoWeAre } from "./IntroBlocks";
import OperatingSystem from "./OperatingSystem";
import Capabilities from "./Capabilities";
import Creators from "./Creators";
import SelectedWork from "./SelectedWork";
import Universe from "./Universe";
import Brands from "./Brands";
import Manifesto from "./Manifesto";
import FinalCTA from "./FinalCTA";

export default function Home() {
  return (
    <>
      <Hero />
      <Intro />
      <WhoWeAre />
      <OperatingSystem />
      <Capabilities />
      <Creators />
      <SelectedWork />
      <Universe />
      <Brands />
      <Manifesto />
      <FinalCTA />
    </>
  );
}
